var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionReceivedActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.18,
    height: 26.556,
    viewBox: "0 0 26.18 26.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12434",
    "data-name": "Group 12434",
    transform: "translate(-728.7 -300.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22523",
    "data-name": "Path 22523",
    d: "M15485.765,2259.1h24.318v24.539h-24.318Z",
    transform: "translate(-14756 -1958)",
    fill: "#04a7d0",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Your_Order",
    "data-name": "Your Order",
    transform: "translate(727.29 298.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22059",
    "data-name": "Path 22059",
    d: "M26.843,1.5H2.158a.448.448,0,0,0-.448.448V27.008a.448.448,0,0,0,.448.448H26.843a.448.448,0,0,0,.448-.448V1.948A.448.448,0,0,0,26.843,1.5ZM26.4,5.08H16.738V2.4H26.4Zm-13.238.9h2.685V13.4l-1.029-1.02a.43.43,0,0,0-.627,0L13.157,13.4ZM15.843,2.4V5.08H13.157V2.4ZM2.605,2.4h9.657V5.08H2.605ZM14.948,26.561V20.3h2.685v6.265Zm7.16,0V20.3h2.685v6.265Zm4.287,0h-.707V19.848a.448.448,0,0,0-.448-.448H21.66a.448.448,0,0,0-.448.448v6.713H18.528V19.848a.448.448,0,0,0-.448-.448H14.5a.448.448,0,0,0-.448.448v6.713H2.605V5.975h9.657v8.5a.448.448,0,0,0,.277.412.421.421,0,0,0,.483-.1L14.5,13.323l1.477,1.468a.421.421,0,0,0,.313.134.385.385,0,0,0,.17,0,.448.448,0,0,0,.277-.448v-8.5H26.4Z",
    stroke: "#000",
    strokeWidth: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionReceivedActive);
export default __webpack_public_path__ + "static/media/Subscription-Received-Active.79244bee03085f9020547d182d8d0246.svg";
export { ForwardRef as ReactComponent };